import {toTwoDecimals as wasmToTwoDecimals} from '../payments';

/**
 * Convert number to two decimals, dropping any zeros at the end.
 *
 * Delegates to the WASM-backed `lib/payments` implementation, which
 * rounds half-up exactly (`1.005 → 1.01`, not `1.00`). The legacy
 * inline `Math.round(number * 100) / 100` mis-rounded at scale-100
 * float-drift boundaries — see OWA-451.
 *
 * **For DISPLAY only.** Intermediate calculations should stay at
 * scale 4 (use `addMoney` / `subtractMoney` / `multiplyMoneyBy` from
 * `lib/payments`); only round at the final UI boundary.
 *
 * @param {number} number
 * @returns {number}
 */
export function toTwoDecimals(number: number): number {
    return wasmToTwoDecimals(number);
}
